export default {
  搭建商信息: "Builder Information",
  社会统一信用代码: "Social Unified Credit Code",
  请输入社会统一信用代码: "Please enter the Unified Social Credit Code",
  请输入正确的社会统一信用代码:
    "Please enter the correct Unified Social Credit Code",
  施工单位名称: "Name of Builder Unit",
  请输入施工单位名称: "Please enter the name of the Builder Unit.",
  施工负责人: "Person in charge of the builder",
  请输入施工负责人: "Please enter the person in charge of builder",
  施工负责人联系电话: "Contact telephone for builder person in charge",
  请输入正确的手机号码: "Please enter the correct mobile phone number.",
  请输入施工负责人联系电话:
    "Please enter the telephone number of the construction person in charge.",
  值守电工: "Electrician on duty",
  请输入值守电工: "Please enter the electrician on duty",
  值守电工联系电话: "On-duty electrician contact telephone",
  请输入值守电工联系电话:
    "Please enter the telephone number of the electrician on duty",
  邮箱: "Mailbox",
  请输入正确的邮箱: "Please enter the correct mailbox",
  请输入邮箱: "Please enter your mailbox",
  传真: "Fax",
  请输入传真: "Please enter a fax",
  "用于接收报图审核结果，请填写正确的邮箱":
    "For receiving the report review results, please enter the correct email",
  "施工单位和现场实际实施单位为同一个单位?":
    "The Builder Unit and the actual construction Unit on site are the same unit?",
  是: "Yes",
  否: "No",
  公司名称: "Company name",
  联系人: "Contact person",
  联系电话: "Contact number",
  施工单位简称: "Abbreviation of Builder Unit",
  请输入施工单位简称: "Please input the abbreviation of Builder Unit",
  地址: "Address",
  请输入地址: "Please enter the address",
  固定电话: "Fixed telephone",
  请输入固定电话: "Please enter the fixed line number",
  邮箱验证码: "E-mail verification code",
  请输入邮箱验证码: "Please enter the email verification code",
  请输入正确的邮箱验证码: "Please enter the correct email verification code",
  校验失败:"VERIFICATION FAILED",
  验证码不正确: "Incorrect verification code",
  请先输入邮箱: "Please enter email",
  请输入公司名称: "Please enter the name of the construction company",
  请输入电话:"Please enter the contact phone number of the person in charge of construction",
  请输入负责人:"Please enter the person in charge of construction",
  获取验证码:'Obtain verification code'
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsProducerInfo.js